/**
 * TC Service Category Service — the typing center's own service categories (Service Catalog).
 */

import ApiService from './api.service';

const getTypingCenterId = () => {
  return (
    localStorage.getItem('typingCenterId') ||
    JSON.parse(localStorage.getItem('currentUser') || '{}')?.typingCenterId
  );
};

const tcServiceCategoryService = {
  // [{ id, name, description, service_count, created_at }], sorted by name
  getAll: async () => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.get('/api/tc-service-categories', { params: { typingCenterId } });
    return response?.data?.data || [];
  },

  create: async (data) => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.post('/api/tc-service-categories', { typingCenterId, ...data });
    return response?.data?.data || response?.data;
  },

  update: async (id, data) => {
    const response = await ApiService.put(`/api/tc-service-categories/${id}`, data);
    return response?.data?.data || response?.data;
  },

  remove: async (id) => {
    const response = await ApiService.delete(`/api/tc-service-categories/${id}`);
    return response?.data;
  },

  seedDefaults: async () => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.post('/api/tc-service-categories/seed', { typingCenterId });
    return response?.data?.data || response?.data;
  }
};

export default tcServiceCategoryService;
